import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { EnergyItem } from '../../data-access/group-analysis.interface';

@Component({
  selector: 'lib-energy-summary',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    TranslateModule,
    MatMenuModule,
  ],
  templateUrl: './energy-summary.component.html',
  styleUrl: './energy-summary.component.css',
})
export class EnergySummaryComponent {
  @Input() items: EnergyItem[] = [];
  @Input() totalEnergy = 0;
  @Input() unit = 0;

  @Output() csvClick = new EventEmitter<void>();

  displayedColumns = [
    'index',
    'name',
    'energy',
    'totalEnergyCost',
    'proportion',
    'emission',
  ];

  calEmission(kwh: number) {
    return (kwh * 0.4999) / 1000;
  }
        
  calUsedEnergy(kwh: number) {
    return kwh * this.unit;
  }
}
